// src/services/commodity/CommoditySearch.ts
import { BaseTenantSearch } from '@/services/_base/BaseTenantSearch'
import { type CommodityType } from '@/types/CommodityType'
import type { IFirestoreService } from '@/platform/firebase/firestore'

type Session = { tenantId?: string; yardId?: string; userId?: string }

export class CommoditySearch extends BaseTenantSearch<CommodityType> {
  constructor(session: Session, firestore: IFirestoreService) {
    super('commodity_types', session, 'commodity.search', firestore)
  }

  /** Filter to active commodity types */
  active() {
    this.where('is_active', '==', true)
      .where('is_deleted', '==', false)
      .appendToMetaName('active')
    return this
  }

  /** Filter to favorite commodity types */
  favorites() {
    this.where('is_favorite', '==', true)
      .where('is_active', '==', true)
      .where('is_deleted', '==', false)
      .appendToMetaName('favorites')
    return this
  }

  /** Filter by category */
  byCategory(category: string) {
    this.where('category', '==', category)
      .appendToMetaName('byCategory')
    return this
  }

  /** Prefix search on name */
  prefixName(termRaw: string, limit = 25) {
    const t = termRaw.trim().toLowerCase()
    const end = `${t}\uf8ff`
    this.where('name', '>=', t)
      .where('name', '<=', end)
      .orderBy('name', 'asc')
      .limit(limit)
      .appendToMetaName('prefix')
    return this
  }

  /** Search by text (name, category, or description) */
  byText(query: string) {
    const q = query.toLowerCase().trim()
    // For now, we'll search by name prefix
    // In the future, this could be enhanced with full-text search
    this.where('name', '>=', q)
      .where('name', '<=', `${q}\uf8ff`)
      .appendToMetaName('byText')
    return this
  }

  /** Get all active commodities (no filters) */
  all() {
    this.where('is_active', '==', true)
      .where('is_deleted', '==', false)
      .orderBy('name', 'asc')
      .appendToMetaName('all')
    return this
  }
}

